import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Separator, Tag } from '~/components';
import { useIsExternalUser } from '~/hooks/useIsExternalUser';
import { TruncateWithTooltip } from '~/modules/settings/components/TruncateWithTooltip';
import { MAX_TAG_CHARACTERS } from '~/modules/settings/constants';
import type { UserListItem } from '~settings/api/lib/schemas';
import { HeaderSmall } from '~settings/components/HeaderSmall';
import { SETTINGS_ROUTES } from '~settings/config/routes';

interface LabelAdminsProps {
  adminUsers: UserListItem[];
}

export function LabelAdmins({ adminUsers }: LabelAdminsProps) {
  const { t } = useTranslation('settings');
  const navigate = useNavigate();
  const isCurrentUserExternal = useIsExternalUser();

  if (!adminUsers?.length) {
    return null;
  }

  return (
    <div>
      {!isCurrentUserExternal && <Separator className="my-lg" />}
      <HeaderSmall>{t('labelAdmins')}</HeaderSmall>
      <ul className="flex flex-wrap gap-x-xs gap-y-sm">
        {adminUsers.map((user) => (
          <Tag
            variant="secondary"
            key={user.id}
            size="lg"
            asChild
            className="max-w-full cursor-pointer gap-xs"
            onClick={() => navigate(SETTINGS_ROUTES.USER_DETAIL(user.id))}
          >
            <li>
              <span className="size-md rounded-full text-center text-caption-sm leading-4 bg-emphasis-strong group-hover:bg-emphasis-default">{`${user.firstName[0]}${user.lastName[0]}`}</span>
              <TruncateWithTooltip maxCharacters={MAX_TAG_CHARACTERS}>
                {user.fullName}
              </TruncateWithTooltip>
            </li>
          </Tag>
        ))}
      </ul>
    </div>
  );
}

LabelAdmins.displayName = 'LabelAdmins';
